/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Email_LedeInputs */

const en_us2_auth_email_lede = /** @type {(inputs: Auth_Email_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We'll send a 6-digit code. No password to remember.`)
};

const pt_br2_auth_email_lede = /** @type {(inputs: Auth_Email_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mandamos um código de 6 dígitos. Nada de senha para decorar.`)
};

const es_419_auth_email_lede = /** @type {(inputs: Auth_Email_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te enviamos un código de 6 dígitos. Sin contraseña que recordar.`)
};

const pt_pt2_auth_email_lede = /** @type {(inputs: Auth_Email_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviamos um código de 6 dígitos. Sem palavra-passe para decorar.`)
};

const fr_fr2_auth_email_lede = /** @type {(inputs: Auth_Email_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On t'envoie un code à 6 chiffres. Aucun mot de passe à retenir.`)
};

const de_de2_auth_email_lede = /** @type {(inputs: Auth_Email_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir schicken dir einen 6-stelligen Code. Kein Passwort zum Merken.`)
};

const it_it2_auth_email_lede = /** @type {(inputs: Auth_Email_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ti mandiamo un codice di 6 cifre. Nessuna password da ricordare.`)
};

/**
* | output |
* | --- |
* | "We'll send a 6-digit code. No password to remember." |
*
* @param {Auth_Email_LedeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const auth_email_lede = /** @type {((inputs?: Auth_Email_LedeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Email_LedeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_auth_email_lede(inputs)
	if (locale === "es-419") return es_419_auth_email_lede(inputs)
	if (locale === "pt-PT") return pt_pt2_auth_email_lede(inputs)
	if (locale === "fr-FR") return fr_fr2_auth_email_lede(inputs)
	if (locale === "de-DE") return de_de2_auth_email_lede(inputs)
	if (locale === "it-IT") return it_it2_auth_email_lede(inputs)
	return en_us2_auth_email_lede(inputs)
});
export { auth_email_lede as "auth.email_lede" }